import { css, html, LitElement } from 'lit-element';
import '../ki-popup/ki-popup';
import '../ki-list/ki-list';
import '@material/mwc-checkbox';

export default class KiSearchFilterAction extends LitElement {
  // language=CSS
  static styles = css`
    :host {
      display: block;
    }

    .hide {
      display: none !important;
    }

    ki-popup {
      min-width: 180px;
      bottom: 10%;
      overflow: auto;
    }

    ki-icon {
      text-align: center;
      width: 26px;
      height: 26px;
      border-radius: 20px;
      flex: 0 0 26px;
      vertical-align: middle;
      font-size: 16px;
      display: block;
      padding: 5px;
    }

    ki-icon.btn {
      cursor: pointer;
    }

    ki-icon.btn:hover {
      color: #4a4a49;
    }

    ki-icon.btn.active {
      color: white;
      background: var(--theme-color, #0056a0);
    }

    ki-list-item mwc-checkbox {
      --mdc-theme-secondary: var(--theme-color, #0056a0);
    }

    ki-list-item {
      padding: 5px;
    }

    ki-list-item:hover {
      color: inherit;
    }

    ki-list-item .label {
      display: inline-block;
      vertical-align: top;
      line-height: 40px;
      padding: 0px 10px;
    }
  `;

  constructor() {
    super();
    this.active = false;
    this.fieldList = [];
    this.filterFields = [];
  }

  static get properties() {
    return {
      fieldList: { type: Array },
      filterFields: { type: Array },
      active: { type: Boolean },
    };
  }

  render() {
    // language=html
    return html`
      <ki-icon
        id="icon"
        class="btn ${this.active ? 'active' : ''}"
        @click="${this.toggleActive}"
        icon="ki ki-cog"
      ></ki-icon>
      <ki-popup for="icon" right="0" top="40" .visible="${this.active}">
        <ki-list>
          ${this.fieldList.map(f => {
            return html`
              <ki-list-item>
                <mwc-checkbox
                  name="${f.field}"
                  .checked="${this.filterFields.indexOf(f.field) >= 0}"
                  @change="${this._updateFilter}"
                ></mwc-checkbox>
                <div class="label">${f.label}</div>
              </ki-list-item>
            `;
          })}
        </ki-list>
      </ki-popup>
    `;
  }

  _updateFilter() {
    // TODO bug data flow
    this.filterFields = [...this.renderRoot.querySelectorAll('ki-popup mwc-checkbox')]
      .filter(ele => ele.checked)
      .map(ele => ele.getAttribute('name'));
    this.dispatchEvent(
      new CustomEvent('changing', { detail: { filterFields: this.filterFields } }),
    );
  }

  toggleActive() {
    // get all filters
    this.active = !this.active;
    if (!this.active) {
      this.dispatchEvent(
        new CustomEvent('changed', { detail: { filterFields: this.filterFields } }),
      );
    }
  }
}

customElements.define('ki-search-filter-action', KiSearchFilterAction);
